import { StepType, TourProvider } from '@reactour/tour';
import noop from 'lodash/noop';
import { FC, memo, useMemo } from 'react';

import { DefaultStepContent, TourContent, TourParamsProvider } from './components';
import { TutorialProviderProps } from './TutorialProvider.types';

/**
 * The TutorialProvider component provides the display of tutorial popups. Based on lib: https://docs.react.tours/
 */
export const TutorialProvider: FC<TutorialProviderProps> = memo((props) => {
    const { children, steps, ...otherProps } = props;

    const providerSteps = useMemo<StepType[]>(
        () =>
            steps.map(({ content, selector, position }, index) => ({
                selector,
                content: () => <DefaultStepContent>{content}</DefaultStepContent>,
                styles: {
                    popover: (base) => ({
                        ...base,
                        padding: '0',
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        ...(index === 0 ? { transition: 'none' } : {}),
                    }),
                },
                padding: 0,
                position: position ?? ((data) => [data.right - data.width, data.bottom + 16]),
            })),
        [steps]
    );

    return (
        <TourProvider
            onClickMask={steps.length > 1 ? noop : undefined} // empty for prevent close
            ContentComponent={TourContent}
            steps={providerSteps}
            {...{ disableWhenSelectorFalsy: true }} // problem with types
            {...otherProps}
        >
            <TourParamsProvider>{children}</TourParamsProvider>
        </TourProvider>
    );
});
